import { css } from '@emotion/react';

export default css`
  position: relative;

  > div {
    display: flex;
    position: absolute;
    top: 50%;
    left: 50%;
    width: 200px;
    height: 200px;
    translate: -50% -300%;
    scale: 4;
  }
    p {
      margin: auto;
      font-size: 1.5rem;
    }
      span {
        display: block;
      }
`;